import { jsx } from "panel";
import { selx } from "clsx";
import { SvgIconEl } from "common/components/svg-icon";
import styles from "./index.module.styl";
export function template() {
  const iconStyles = this.helpers.getIconStyles();
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpCheckboxWrapper), class: this.helpers.getClasses(), "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(
    "div",
    {
      sel: selx(styles.mpCheckboxIcon, `item-icon`),
      key: JSON.stringify(iconStyles),
      style: iconStyles
    },
    /* @__PURE__ */ jsx("div", { sel: selx(styles.mpCheckboxAnimationLayer) }),
    /* @__PURE__ */ jsx(SvgIconEl, { attrs: this.helpers.getIconAttributes(), "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" })
  ), this.attr(`icon`) ? /* @__PURE__ */ jsx("div", { sel: selx(styles.mpCheckboxAdditionalIcon) }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: this.attr(`icon`)
  } })) : null, /* @__PURE__ */ jsx("div", { sel: selx(styles.mpCheckboxLabel) }, /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" })));
}
